// Constants
import { ResponsiveHeaderWidths } from "@ms/planner-generic-controls/lib/local/constants/StyleConstants";
import { ElementIds } from "@ms/uno-constants/lib/local/UIConstants";
// Controls
import { Button, Tooltip } from "@fluentui/react-components";
import { Copilot, EditPerson, LockBundled } from "@ms/planner-generic-controls/lib/local/icons";
import { ShareMenuButton } from "../../shareMenuButton/ShareMenuButton";
import { ContainerType } from "@ms/planner-models/lib/local/service/planner/enumerations/IPlannerEnumerations";
// Resources
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
// Styles
import { usePlanHeaderControlsStyles } from "./PlanHeaderControls.styles";
// Utilities
import * as React from "react";
/**
 * Plan Header Controls of the PlanHeader
 * @param props Plan Header Controls props
 * @returns Returns Plan Header Controls
 */ export const PlanHeaderControls = ({ plan, onClickJoinPlan, showMoreButton, headerOverflowMenu, shareMenuButtonProps, trialButton, onClickCopilotButton, shouldRenderCopilotButton, width })=>{
    const classes = usePlanHeaderControlsStyles();
    const containerType = plan.container.containerType;
    const isPrivatePlan = containerType === ContainerType.User;
    return /*#__PURE__*/ React.createElement("div", {
        "data-testid": "plan-header-controls",
        className: classes.root
    }, isPrivatePlan && /*#__PURE__*/ React.createElement(Tooltip, {
        content: Strings.PlanHeader_PrivatePlanStatus,
        relationship: "label"
    }, /*#__PURE__*/ React.createElement("div", {
        className: classes.iconContainer,
        tabIndex: 0
    }, /*#__PURE__*/ React.createElement(LockBundled, null))), trialButton, shouldRenderCopilotButton && /*#__PURE__*/ React.createElement(Button, {
        "data-testid": "plan-header-controls-button-copilot",
        appearance: width ? width >= ResponsiveHeaderWidths.maxWidth1024 ? "secondary" : "subtle" : "secondary",
        className: classes.button,
        onClick: onClickCopilotButton,
        icon: /*#__PURE__*/ React.createElement(Copilot, null)
    }, width ? width >= ResponsiveHeaderWidths.maxWidth1024 && Strings.Copilot_Copilot : Strings.Copilot_Copilot), onClickJoinPlan && /*#__PURE__*/ React.createElement(Tooltip, {
        content: Strings.PlanHeader_JoinTooltip,
        relationship: "label"
    }, /*#__PURE__*/ React.createElement(Button, {
        "data-testid": "plan-header-controls-button-edit-person",
        appearance: width ? width >= ResponsiveHeaderWidths.maxWidth1024 ? "secondary" : "subtle" : "secondary",
        "aria-describedby": ElementIds.HeaderJoinButtonTooltip,
        onClick: onClickJoinPlan,
        className: classes.button,
        icon: /*#__PURE__*/ React.createElement(EditPerson, null)
    }, width ? width >= ResponsiveHeaderWidths.maxWidth1024 && Strings.PlanHeader_JoinText : Strings.PlanHeader_JoinText)), /*#__PURE__*/ React.createElement(ShareMenuButton, shareMenuButtonProps), showMoreButton && headerOverflowMenu);
};
